import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  ConfirmDialogPopupComponent,
  SharedTableActionEffects, SharedTableFilteredDataReducer
} from '@app/shared';
import { NgxCountdownModule } from '@modules/sales/components/task-management/ngx-countdown/ngx-countdown.module';
import { TruncateModule } from '@yellowspot/ng-truncate';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// Third party modules;
import { MatIconModule } from '@angular/material';
import { ConnectsAiModule } from '@modules/sales/components/task-management/connects-ai/connects-ai.module';
import { OpenscapeModule } from '@modules/sales/components/task-management/open-scape/open-scape.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { NgxPrintModule } from 'ngx-print';
import { SignaturePadModule } from 'ngx-signaturepad';
import { PageReusableComponentsModule } from '../shared/components/page-reusable-components.module';
import { PopupLoaderModule } from '../shared/components/popup-loader/popup-loader.module';
import { PrimeNGComponentsModule } from '../shared/components/primeng-components.module';
import { FormControlErrorDirectivesModule } from '../shared/directives/form-control-errors/form-control-error-directives.module';
import { MaterialModule } from '../shared/material.module';
import { CustomFormControlsModule } from './components/reusable-form-controls/custom-form-control/custom-form-controls.module';
import { AllDirectivesModule } from './directives/all-directives.module';
import { AllPipesModule } from './pipes/all-pipes.module';
import { PrimeNgModule } from './primeNg.module';
import { AngularEditorModule } from '@kolkov/angular-editor';

const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [ConfirmDialogPopupComponent],
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule, NgxPrintModule, NgxCountdownModule,
    PrimeNgModule, MaterialModule,
    TruncateModule, PopupLoaderModule, CustomFormControlsModule, FormControlErrorDirectivesModule, OpenscapeModule, ConnectsAiModule, PrimeNGComponentsModule,
    NgxMaskModule.forRoot(maskConfig),
    RouterModule, InfiniteScrollModule, AllPipesModule, AllDirectivesModule, PageReusableComponentsModule,
    SignaturePadModule, MatIconModule, AngularEditorModule,
    DragDropModule,
    StoreModule.forFeature('TableFilteredData', SharedTableFilteredDataReducer),
    EffectsModule.forFeature([SharedTableActionEffects])
  ],

  exports: [
    CommonModule, ReactiveFormsModule, FormsModule, NgxMaskModule, TruncateModule,
    NgxCountdownModule,MaterialModule,
    NgxPrintModule, MatIconModule, AngularEditorModule,
    PopupLoaderModule, CustomFormControlsModule, FormControlErrorDirectivesModule,
    OpenscapeModule, ConnectsAiModule, PrimeNGComponentsModule, AllPipesModule, AllDirectivesModule, PageReusableComponentsModule,
    DragDropModule, SignaturePadModule, PrimeNgModule],
  entryComponents: [ConfirmDialogPopupComponent]
})
export class SharedModule { }
